/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';

/**
 * 
 * @export
 * @interface GetSupportingExaminationDictDto
 */
export interface GetSupportingExaminationDictDto {
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDictDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDictDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSupportingExaminationDictDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDictDto
     */
    type?: GetSupportingExaminationDictDtoTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof GetSupportingExaminationDictDto
     */
    systemNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSupportingExaminationDictDto
     */
    synevoCode: string;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetSupportingExaminationDictDto
     */
    test: GetTestDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSupportingExaminationDictDto
     */
    alternativeTests?: Array<string> | null;
}


/**
 * @export
 */
export const GetSupportingExaminationDictDtoTypeEnum = {
    helpExam: 'helpExam',
    specialisedConsultation: 'specialisedConsultation'
} as const;
export type GetSupportingExaminationDictDtoTypeEnum = typeof GetSupportingExaminationDictDtoTypeEnum[keyof typeof GetSupportingExaminationDictDtoTypeEnum];


/**
 * Check if a given object implements the GetSupportingExaminationDictDto interface.
 */
export function instanceOfGetSupportingExaminationDictDto(value: object): value is GetSupportingExaminationDictDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('synevoCode' in value) || value['synevoCode'] === undefined) return false;
    if (!('test' in value) || value['test'] === undefined) return false;
    return true;
}

export function GetSupportingExaminationDictDtoFromJSON(json: any): GetSupportingExaminationDictDto {
    return GetSupportingExaminationDictDtoFromJSONTyped(json, false);
}

export function GetSupportingExaminationDictDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupportingExaminationDictDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'],
        'type': json['type'] == null ? undefined : json['type'],
        'systemNumber': json['systemNumber'] == null ? undefined : json['systemNumber'],
        'synevoCode': json['synevoCode'],
        'test': GetTestDtoFromJSON(json['test']),
        'alternativeTests': json['alternativeTests'] == null ? undefined : json['alternativeTests'],
    };
}

export function GetSupportingExaminationDictDtoToJSON(value?: GetSupportingExaminationDictDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'type': value['type'],
        'systemNumber': value['systemNumber'],
        'synevoCode': value['synevoCode'],
        'test': GetTestDtoToJSON(value['test']),
        'alternativeTests': value['alternativeTests'],
    };
}

